import { createAction } from "redux-actions";
import { GET_STATES } from "../constants";
import { feathersFindDataAll } from "../services";

export const getStates = createAction(GET_STATES, (query) => feathersFindDataAll('states', query)() )